import { Controller } from "@hotwired/stimulus"

const THEME_KEY = "color-theme"

export default class extends Controller {
  connect() {
    const theme = localStorage.getItem(THEME_KEY)
    if (theme) document.documentElement.classList.toggle("dark", theme === "dark")

    this.updateButton()
  }

  toggle() {
    const isDark = document.documentElement.classList.toggle("dark")
    localStorage.setItem(THEME_KEY, isDark ? "dark" : "light")
    this.updateButton()
  }

  updateButton() {
    const isDark = document.documentElement.classList.contains("dark")

    this.element.querySelector("#theme-toggle-dark-icon").classList.toggle("hidden", isDark)
    this.element.querySelector("#theme-toggle-light-icon").classList.toggle("hidden", !isDark)
    this.element.setAttribute("aria-label", isDark ? "Passer en mode clair" : "Passer en mode sombre")
    this.element.setAttribute("aria-pressed", String(isDark))
  }
}
